import { Space, Text } from '@billy/design-system'
import React, { ReactElement, ReactNode } from 'react'

import * as Styled from './styles'

interface PurchaseCardHeaderProps {
  description: ReactNode
  title: ReactNode
}

export const PurchaseCardHeader = ({ description, title }: PurchaseCardHeaderProps): ReactElement => (
  <Styled.HeaderContainer flexDirection="column" alignItems="center">
    <Text variant="h1" alignment="center">
      {title}
    </Text>
    <Space size="s8" />
    <Text alignment="center">{description}</Text>
  </Styled.HeaderContainer>
)
